import React from "react";
import { useSelector } from "react-redux";
import auth from "services/auth";
import moneyFormatter from "services/moneyFormatter";
import { __ } from "services/Translator";

// PWA-only compact dashboard hero. Visibility is gated to mobile in CSS
// (.pwa-dashboard-hero is display:none by default, flex under max-width 767px).
// All data is read synchronously from Redux / the persisted user object — there
// are NO API calls, so it renders instantly and never leaves the area under the
// PWA header empty while the async dashboard content loads.
const PwaDashboardHero = () => {
  // Balance: same source as the PWA header (Redux userBalance store).
  const userBalance = useSelector((state) => state.userBalance);
  const wallet = userBalance?.wallets?.[0];

  // Username: the Redux userAuth store only holds isAuthenticated, so the name
  // comes from the persisted user object (auth.getUser() — synchronous, no fetch).
  const user = auth.getUser();
  if (!user) {
    // Guest / pre-login: render nothing rather than an empty card.
    return null;
  }

  const displayName = user.username || user.first_name || __("Player");
  const initial = (displayName || "P").trim().charAt(0).toUpperCase();

  return (
    <div className="pwa-dashboard-hero">
      <div className="pwa-dashboard-hero__avatar" aria-hidden="true">
        {initial}
      </div>
      <div className="pwa-dashboard-hero__meta">
        <span className="pwa-dashboard-hero__name">{displayName}</span>
        <span className="pwa-dashboard-hero__balance">
          <span className="pwa-dashboard-hero__balance-label">{__("Balance")}</span>
          <span className="pwa-dashboard-hero__balance-value">
            {wallet && moneyFormatter.currencyIcon(wallet.currency)}
            {wallet ? parseFloat(wallet.balance).toFixed(2) : "0.00"}
          </span>
        </span>
      </div>
    </div>
  );
};

export default PwaDashboardHero;
